import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { MenuItem } from '@material-ui/core';

import { downloadFile } from '@helpers';
import { Menu } from 'components/Menu';
import { useReports } from 'hooks';

export const DotsMenu = ({ link, id }) => {
  const { t } = useTranslation();
  const { deleteReport } = useReports();
  const [close, setClose] = useState(null);

  const handleRemove = () => {
    deleteReport(id);
    setClose(false);
  };

  return (
    <Menu
      icon="ic_menu_dots.svg"
      data-testid="dots-icon"
      style={{ alignContent: 'center' }}
      imageStyle={{ height: '18px' }}
      closePopper={close}
    >
      <MenuItem
        id="download-report"
        onClick={() => downloadFile('report', link)}
        data-testid="download"
        disabled={!link}
      >
        {t('common.download')}
      </MenuItem>
      <MenuItem id="delete-report" data-testid="delete" onClick={() => handleRemove()}>
        {t('paymentsFoundsOut.common.delete')}
      </MenuItem>
    </Menu>
  );
};
